import styled from "styled-components";

export const Wrapper = styled.div`
  flex: 1;
  background: #fff;
  border: 1px solid #e9e9e9;
  box-shadow: 0 3px 10px rgba(17, 24, 39, 0.06);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.strong`
  width: 100%;
  font-size: 16px;
  font-weight: 700;
`;

export const QrArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
`;

export const QrImage = styled.img`
  width: 180px !important;
  max-width: 100% !important;
  margin-bottom: 0 !important;
`;

export const QrLoading = styled.div`
  width: 180px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QrSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e5e5e5;
  border-top: 4px solid #e71037;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const PixButton = styled.button`
  width: 100%;
  max-width: 220px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: #f5f5f5;
  color:  #1A1A1A;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  svg, img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const CopyFeedback = styled.span`
  margin-top: 10px;
  font-size: 13px;
  color: #00a86b;
  font-weight: 600;
  text-align: center;
`;

export const Toast = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background: #00a86b;
  color: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  z-index: 99999;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);

  transform: ${({ show }) => (show ? "translateX(0)" : "translateX(120%)")};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: all 0.25s ease;
`;